import React from 'react';
import Login from './Login';

import { Menu, Icon } from 'semantic-ui-react';

export default class Navbar extends React.Component {

  render() {
    return(
      <Menu pointing icon='labeled'>
        <Menu.Item active name="ban">
          <Icon name="ban"/>
          Cancellations
        </Menu.Item>
        <Menu.Item position="right">
          <Login />
        </Menu.Item>
      </Menu>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Navbar.js